import React, { useState, useEffect, useMemo, Fragment } from 'react';
import { Form, FormGroup, Input, Collapse, CustomInput, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { communityActions } from '../../../core/community-search/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getSystemById } from '../../../core/system';
import { SYSTEM_ID_SENIORITIES } from '../../../core/constants';

export const CommunityFilters = ({ filters, setFilters, search, setSearch, refreshComponent }) => {
    const dispatch = useDispatch()
    const seniorities = useSelector(state => getSystemById(state, SYSTEM_ID_SENIORITIES))
    const { quadrants } = useSelector(state => state.questions)
    const talents = useSelector(state => state.questions.items)

    const [quadrants_talents, setQuadrants_talents] = useState([])
    const [collapsed, setCollapsed] = useState(true)
    const [quadrantsChecked, setQuadrantsChecked] = useState([])
    const [unappliedFilters, setUnappliedFilters] = useState([...filters])

    const toggleNavbar = () => {
        setCollapsed(!collapsed)
        setQuadrantsChecked(getAllQuadrantsChecked())
        if (!collapsed) {
            setUnappliedFilters([...filters])
            refreshComponent()
        }
    }

    const getAllQuadrantsChecked = () => {
        return quadrants_talents?.filter((quadrant) => allSelected(quadrant.id)).map((quadrant) => quadrant.id) || [];
    }

    const toggleQuadrant = (index) => {
        let quadrants = [...quadrants_talents]
        quadrants[index].collapse = !quadrants[index].collapse
        setQuadrants_talents(quadrants)
    }

    useEffect(() => {
        if (!quadrants_talents || !quadrants_talents.length)
            quadrants.forEach(quadrant => {
                setQuadrants_talents(
                    quadrants_talents => [
                        ...quadrants_talents,
                        {
                            ['id']: quadrant.id,
                            ['name']: quadrant.name,
                            ['collapse']: false,
                            ['talents']: getTalents(quadrant.id)
                        }
                    ]);
            })
    }, [quadrants])

    const searchMembers = () => {
        if (search) dispatch(communityActions.searchMemberByFilters({ 'name': search }, 1))
        else dispatch(communityActions.searchMemberByFilters({}, 1))

        clearAllFilters()
    }

    const getTalents = (id) => {
        let quadrantTalents = []
        talents.forEach(talent => {
            if (talent.quadrant.id === id) quadrantTalents.push(talent)
        });
        return quadrantTalents
    }

    const handleKeyPress = (event) => {
        if (event.charCode === 13) {
            searchMembers()
        }
    }

    const handleInputChange = (target, name, type, quadrant_id = null, calledOfModal = false) => {
        let id = parseInt(target.value) ? parseInt(target.value) : target.value
        let filter = unappliedFilters
        let quadrantChecked = quadrantsChecked

        if (target.checked) {
            filter.push({ id: id, name: name, type: type, mp: name })
        } else {
            filter.splice(filter.map(function (item) {
                if (item.type === type) return item.id
            }).indexOf(id), 1)
        }

        if (type === 'talents' && quadrant_id) {
            allSelected(quadrant_id) ? quadrantChecked.push(quadrant_id)
                : quadrantChecked.indexOf(quadrant_id) !== -1 && quadrantChecked.splice(quadrantChecked.indexOf(quadrant_id), 1)
        }

        setUnappliedFilters(filter)
    }

    const handleQuadrantCheck = (quadrant_id) => {
        quadrantsChecked.includes(quadrant_id) ? deselectAll(quadrant_id) : selectAll(quadrant_id)
        //quadrantsChecked.find(id => id === quadrant_id) ? deselectAll(quadrant_id) : selectAll(quadrant_id)
    }

    const allSelected = (quadrant_id) => {
        let quadrant = quadrants_talents.find(quadrant => quadrant.id === quadrant_id)
        let allSelected = true
        if (quadrant)
            quadrant.talents.forEach(talent => {
                if (!unappliedFilters.find(filter => filter.type === 'talents' && filter.id === talent.id)) allSelected = false
            });
        return allSelected
    }

    const deselectAll = (quadrant_id) => {
        let quadrant = quadrants_talents.find(quadrant => quadrant.id === quadrant_id)
        let quadrantChecked = quadrantsChecked
        let filter = unappliedFilters
        if (quadrant)
            quadrant.talents.forEach(talent => {
                filter.splice(filter.map(function (item) {
                    if (item.type === 'talents') return item.id
                }).indexOf(talent.id), 1)
            });
        quadrantChecked.splice(quadrantChecked.indexOf(quadrant_id), 1)
        setUnappliedFilters(filter)
        setQuadrantsChecked(quadrantChecked)
    }

    const selectAll = (quadrant_id) => {
        let quadrant = quadrants_talents.find(quadrant => quadrant.id === quadrant_id)
        let quadrantChecked = quadrantsChecked
        let filter = unappliedFilters
        if (quadrant)
            quadrant.talents.forEach(talent => {
                if (!filter.find(filter => filter.type === 'talents' && filter.id === talent.id))
                    filter.push({ id: talent.id, name: talent.name, type: 'talents' })
            });
        quadrantChecked.push(quadrant_id)
        setUnappliedFilters(filter)
        setQuadrantsChecked(quadrantChecked)
    }

    const clearAllFilters = (reload = true) => {
        setUnappliedFilters([])
        setQuadrantsChecked([])
        refreshComponent()

        if (reload && filters != []) {
            setFilters([])
        }
    }

    const filtersApply = () => {
        setFilters(unappliedFilters)
    }

    const quadranTalentsChecks = useMemo(() => {
        return (
            <div className='mb-2'>
                {quadrants_talents.map((quadrant, index) => (
                    <FormGroup key={'quadrant-' + quadrant.id} className="border-bottom mx-n3 px-3 mb-0">
                        <div className='d-flex align-items-center justify-content-between flex-wrap'>
                            <CustomInput
                                checked={quadrantsChecked.includes(quadrant.id)}
                                onChange={() => { handleQuadrantCheck(quadrant.id); toggleQuadrant(index); toggleQuadrant(index) }}
                                // bsSize="sm"
                                className="my-3"
                                type="checkbox"
                                cssModule={{ 'custom-control-label': 'custom-control-label h5 font-weight-normal' }}
                                label={`${quadrant.name !== 'All' ? quadrant.name : "All- Quadrant"} Talents`}
                                id={'quadrant-' + quadrant.id}
                            />
                            <Button color="link text-muted" className="p-0" onClick={() => toggleQuadrant(index)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width={14} height={9} viewBox="0 0 14 9" fill="currentColor" className={quadrant.collapse ? 'fa-flip-vertical' : ''}>
                                    <path d="M13.7,1.9L7.4,8.2C7.4,8.3,7.3,8.3,7.2,8.3c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1L0.3,1.9C0.2,1.8,0.1,1.7,0.1,1.5s0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2L7,6.9l5.8-5.8C12.9,1,12.9,1,13,0.9c0.1,0,0.2,0,0.2,0s0.2,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.2C13.8,1.8,13.8,1.9,13.7,1.9z" />
                                </svg>
                            </Button>
                        </div>
                        <Collapse isOpen={quadrant.collapse} className="w-100 pl-4">
                            <FormGroup className="mb-2">
                                {quadrant.talents.map(talent => (
                                    <CustomInput
                                        key={'talent-' + talent.id}
                                        checked={unappliedFilters.some(filter => filter.type === 'talents' && filter.id === talent.id)}
                                        onChange={({ target }) => { handleInputChange(target, talent.name, 'talents', talent.quadrant.id, true); toggleQuadrant(index); toggleQuadrant(index) }}
                                        value={talent.id}
                                        type="checkbox"
                                        label={talent.name}
                                        id={'talent-' + talent.id}
                                        className="mb-3"
                                        cssModule={{ 'custom-control-label': 'custom-control-label h5 font-weight-normal' }}
                                    />
                                ))}
                            </FormGroup>
                        </Collapse>
                    </FormGroup>
                ))}
            </div>
        );
    }, [quadrants_talents, quadrantsChecked, unappliedFilters, handleQuadrantCheck, handleInputChange]);

    const mindPatternsChecks = useMemo(() => {
        return (
            <div>
            <FormGroup className="border-bottom mx-n3 px-3 mb-0">
                <div className='row'>
                    <div className='col-6'>
                        <CustomInput checked={unappliedFilters && unappliedFilters.find(filter => filter.type === 'mind_patterns' && filter.id === "AKV")} onChange={({ target }) => { handleInputChange(target, "AKV", 'mind_patterns', true); }} className='my-3' cssModule={{ 'custom-control-label': 'custom-control-label h5 font-weight-normal' }} type="checkbox" label="AKV" id="AKV" value="AKV" />
                    </div>
                    <div className='col-6'>
                        <CustomInput checked={unappliedFilters && unappliedFilters.find(filter => filter.type === 'mind_patterns' && filter.id === "AVK")} onChange={({ target }) => { handleInputChange(target, "AVK", 'mind_patterns', true); }} className='my-3' cssModule={{ 'custom-control-label': 'custom-control-label h5 font-weight-normal' }} type="checkbox" label="AVK" id="AVK" value="AVK" />
                    </div>
                </div>
            </FormGroup>
            <FormGroup className="border-bottom mx-n3 px-3 mb-0">
                <div className='row'>
                    <div className='col-6'>
                        <CustomInput checked={unappliedFilters && unappliedFilters.find(filter => filter.type === 'mind_patterns' && filter.id === "KAV")} onChange={({ target }) => { handleInputChange(target, "KAV", 'mind_patterns', true); }} className='my-3' cssModule={{ 'custom-control-label': 'custom-control-label h5 font-weight-normal' }} type="checkbox" label="KAV" id="KAV" value="KAV" />
                    </div>
                    <div className='col-6'>
                        <CustomInput checked={unappliedFilters && unappliedFilters.find(filter => filter.type === 'mind_patterns' && filter.id === "KVA")} onChange={({ target }) => { handleInputChange(target, "KVA", 'mind_patterns', true); }} className='my-3' cssModule={{ 'custom-control-label': 'custom-control-label h5 font-weight-normal' }} type="checkbox" label="KVA" id="KVA" value="KVA" />
                    </div>
                </div>
            </FormGroup>
            <FormGroup className="border-bottom mx-n3 px-3 mb-0">
                <div className='row'>
                    <div className='col-6'>
                        <CustomInput checked={unappliedFilters && unappliedFilters.find(filter => filter.type === 'mind_patterns' && filter.id === "VAK")} onChange={({ target }) => { handleInputChange(target, "VAK", 'mind_patterns', true); }} className='my-3' cssModule={{ 'custom-control-label': 'custom-control-label h5 font-weight-normal' }} type="checkbox" label="VAK" id="VAK" value="VAK" />
                    </div>
                    <div className='col-6'>
                        <CustomInput checked={unappliedFilters && unappliedFilters.find(filter => filter.type === 'mind_patterns' && filter.id === "VKA")} onChange={({ target }) => { handleInputChange(target, "VKA", 'mind_patterns', true); }} className='my-3' cssModule={{ 'custom-control-label': 'custom-control-label h5 font-weight-normal' }} type="checkbox" label="VKA" id="VKA" value="VKA" />
                    </div>
                </div>
            </FormGroup>
            </div>
        )
    }, [quadrants_talents, unappliedFilters, quadrantsChecked, handleInputChange])

    const rolsChecks = useMemo(() => {
        return (
            <Fragment>
                {seniorities?.items?.map((seniority) => {
                    return (
                        <FormGroup key={'fg-seniority-' + seniority.id} className="border-bottom mx-n3 px-3 mb-0">
                            <CustomInput
                                key={'seniority-' + seniority.id}
                                checked={unappliedFilters && unappliedFilters.find(filter => filter.type === 'seniorities' && filter.id === seniority.id)}
                                onChange={({ target }) => { handleInputChange(target, seniority.name, 'seniorities', true); }}
                                className="py-3"
                                cssModule={{ 'custom-control-label': 'custom-control-label h5 font-weight-normal' }}
                                type="checkbox" label={seniority.name} value={seniority.id} id={'seniority-' + seniority.id}
                            />
                        </FormGroup>
                    )
                })
                }
            </Fragment>
        )
    }, [quadrants_talents, unappliedFilters, quadrantsChecked, handleInputChange, seniorities])

    return (
        <>
            <div className='d-flex align-items-center gap-10 mb-4'>
                <div className='flex-fill'>
                    <Form onSubmit={e => { e.preventDefault() }}>
                        <div className="search-member-input rounded border d-flex align-items-center">
                            <Button color='link' className='text-muted p-0' onClick={() => { searchMembers() }} >
                                <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} viewBox="0 0 20 21" fill='currentColor'>
                                    <g>
                                        <path d="M18.1,17.4L18.1,17.4L18.1,17.4c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3
                                            c0,0.1-0.1,0.2-0.2,0.3s-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2l-3.7-3.7l0,0l0,0
                                            c-1.4,1.1-3.2,1.6-5,1.4c-1.8-0.2-3.5-1-4.7-2.4C2.2,12.6,1.6,10.8,1.6,9c0.1-1.8,0.8-3.5,2.1-4.8c1.3-1.3,3-2,4.8-2.1
                                            c1.8-0.1,3.6,0.6,4.9,1.8c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.4,5l0,0l0,0L18.1,17.4z M3.4,9.3L3.4,9.3
                                            C3.4,10.7,3.9,12,5,13c1,1,2.4,1.6,3.8,1.6h0c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4c0.4-1,0.5-2.1,0.3-3.1
                                            c-0.2-1-0.7-2-1.5-2.8S10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2C3.7,7.1,3.4,8.2,3.4,9.3z"/>
                                        <path d="M17.5,18.9c-0.1,0-0.2,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2L13.1,15c-1.5,1.1-3.3,1.6-5.1,1.5
                                            c-1.8-0.2-3.5-1-4.7-2.4c-1.2-1.4-1.8-3.1-1.8-5c0.1-1.8,0.8-3.6,2.1-4.9c1.3-1.3,3-2,4.9-2.1c1.8-0.1,3.6,0.6,5,1.8
                                            c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.5,5.1l3.8,3.8l0,0c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4s0,0.2-0.1,0.4
                                            s-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C17.7,18.9,17.6,18.9,17.5,18.9z M13.1,14.8L13.1,14.8l3.8,3.8c0.1,0.1,0.2,0.1,0.3,0.2
                                            c0.2,0.1,0.4,0.1,0.6,0c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3
                                            c0-0.1-0.1-0.2-0.2-0.3l-0.1,0l0,0l-3.7-3.7l0.1-0.1c1.1-1.4,1.6-3.2,1.4-5c-0.2-1.8-1-3.4-2.4-4.6s-3.1-1.8-4.9-1.8
                                            C6.7,2.2,5,3,3.7,4.2c-1.3,1.3-2,3-2.1,4.8c-0.1,1.8,0.6,3.5,1.8,4.9c1.2,1.4,2.8,2.2,4.6,2.4C9.8,16.5,11.6,16,13.1,14.8
                                            L13.1,14.8z M8.8,14.7c-1.5,0-2.8-0.6-3.8-1.6c-1-1-1.6-2.4-1.6-3.8l0,0c0-1.1,0.3-2.1,0.9-3c0.6-0.9,1.4-1.6,2.4-2
                                            c1-0.4,2.1-0.5,3.1-0.3c1.1,0.2,2,0.7,2.8,1.5c0.8,0.8,1.3,1.7,1.5,2.8c0.2,1.1,0.1,2.1-0.3,3.1c-0.4,1-1.1,1.8-2,2.4
                                            C10.9,14.4,9.8,14.7,8.8,14.7z M3.4,9.3C3.4,10.7,4,12,5,13c1,1,2.3,1.6,3.8,1.6c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4
                                            c0.4-1,0.5-2,0.3-3.1c-0.2-1-0.7-2-1.5-2.7C11.8,4.7,10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2
                                            C3.7,7.2,3.4,8.2,3.4,9.3L3.4,9.3z"/>
                                    </g>
                                </svg>
                            </Button>
                            <Input type="text" className='border-0' id="search_member" name="search_member" defaultValue={search} onKeyPress={(e) => handleKeyPress(e)} onChange={e => setSearch(e.target.value)} placeholder="Search members by name or email"></Input>
                        </div>
                    </Form>
                </div>
                <Button onClick={toggleNavbar} color="green-light" size='sm'>
                    {unappliedFilters.length === 0 &&
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="currentColor" className='mt-n1'>
                            <path d="M12.8,3.1c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.4-0.2-0.6-0.2H2.2C2,2.5,1.8,2.5,1.6,2.6
                        C1.4,2.8,1.3,2.9,1.2,3.1C1.1,3.3,1.1,3.5,1.1,3.7c0,0.2,0.1,0.4,0.3,0.6l0,0L5,8.2v4.1c0,0.2,0.1,0.4,0.2,0.6
                        c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.4,0.1,0.6,0.1s0.4-0.1,0.6-0.2l1.8-1.2c0.1-0.1,0.3-0.2,0.4-0.4C8.9,11.5,9,11.3,9,11.1V8.2
                        l3.6-3.9l0,0c0.1-0.2,0.2-0.4,0.3-0.6C12.9,3.5,12.9,3.3,12.8,3.1z M7.8,7.5C7.7,7.6,7.7,7.8,7.7,7.9V11l-1.3,0.9v-4
                        c0-0.2-0.1-0.3-0.2-0.4L2.7,3.8h8.6L7.8,7.5z"/>
                        </svg>
                    }
                    {unappliedFilters.length > 0 &&
                        <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" className='mt-n1'>
                            <circle fill='#DC0C0D' cx="11" cy="3" r="2.5" />
                            <path fill='#332D2D' d="M9,5.8L7.8,7C7.7,7.1,7.7,7.3,7.7,7.4v3.1l-1.3,0.9v-4c0-0.2-0.1-0.3-0.2-0.4L2.7,3.3l4.8-0.1
                        c0,0-0.1-1.2,0.2-1.3H2.2C2,2,1.8,2,1.6,2.1S1.3,2.4,1.2,2.6C1.1,2.8,1.1,3,1.1,3.2c0,0.2,0.1,0.4,0.3,0.6l0,0L5,7.7v4.1
                        c0,0.2,0.1,0.4,0.2,0.6s0.2,0.3,0.4,0.4c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4-0.1,0.6-0.2l1.8-1.2c0.1-0.1,0.3-0.2,0.4-0.4
                        C8.9,11,9,10.8,9,10.6V7.7l1.2-1.3C9.2,6.1,9,5.8,9,5.8z"/>
                        </svg>
                    }
                    <span className='d-none d-md-inline-block pl-1'>Filter</span>
                </Button>
            </div>

            <Modal isOpen={!collapsed} toggle={toggleNavbar} className="modal-dialog modal-sm modal-dialog-summary float-right">
                <ModalHeader toggle={toggleNavbar} tag="h4">Filter member list</ModalHeader>
                <ModalBody className='px-3 pb-3 pt-2 form-filters-search-members'>
                    <Form onSubmit={e => { e.preventDefault() }}>
                        {quadrants_talents &&
                            <div>
                                <h3 className='h5 mb-2'>Thinking Talents</h3>
                                {quadranTalentsChecks}
                            </div>
                        }

                        <div className="mb-2">
                            <h3 className='h5 py-2 mb-0'>Mind Patterns</h3>
                            {mindPatternsChecks}
                        </div>

                        <div className='mb-2'>
                            <h3 className='h5 py-2 mb-0'>Roles</h3>
                            { rolsChecks }
                        </div>

                        <div className='d-flex align-items-center justify-content-center'>
                            <Button onClick={() => { filtersApply(); toggleNavbar(); }} color="green-light" size='sm'>
                                <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14} viewBox="0 0 15 14" fill="currentColor" className='mr-1'>
                                    <path d="M13.2,4.4l-7,7c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1
                                                        L2.2,8.3C2.2,8.3,2.1,8.2,2.1,8.1C2,8,2,8,2,7.9c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1
                                                        c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1L5.7,10l6.5-6.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.5,0.2
                                                        c0.1,0.1,0.2,0.3,0.2,0.5C13.4,4.1,13.3,4.3,13.2,4.4L13.2,4.4z"/>
                                </svg>
                                Apply Filter</Button>
                            <Button onClick={() => clearAllFilters()} color="link text-red" size='sm'>
                                <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14} viewBox="0 0 15 14" fill='currentColor' className='mr-1'>
                                    <path d="M11.9,10.5c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.3-0.1-0.5-0.2
                                                        L7.5,7.9L4,11.4c-0.1,0.1-0.3,0.2-0.5,0.2s-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.3,0.2-0.5L6.6,7L3.1,3.5
                                                        C3,3.4,2.9,3.2,2.9,3.1c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2S3.9,2.5,4,2.6l3.5,3.5L11,2.6c0.1-0.1,0.3-0.2,0.5-0.2
                                                        c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.5L8.4,7L11.9,10.5z"/>
                                </svg>
                                Clear Filters
                            </Button>
                        </div>
                    </Form >
                </ModalBody >
            </Modal >
        </>
    )
}